function init_gameninja_game(from_php){
    var main=$(".place.gameninja"),
    gameCanvas=main.find("#girlGameJsCanvas"),
    ghostCanvas=main.find("#girlGhostJsCanvas"),
    book=main.find("#bookGameJS"),
    startCanvas=book.find("#bookGameStartJS"),
    startImgCanvas=book.find("#bookGameStartImgJS"),
    animCanvas=main.find("#girlAnimJsCanvas"),
    startIndex=_moduleTimeHandler.getNewIndex(),
    gameIndex=_moduleTimeHandler.getNewIndex();
    
    var pointsStart=[],pointsGame=[];
    var gameState={good:0,bad:0,happy:0,good_max:0,good_all:0,bad_all:0,ended_all:0};
    var level=intval(from_php.level);
    var state={live:3,points:0};
    var conf_general={
        "0":{random_count:1},
        "1":{random_count:3},
        "2":{random_count:4},
        "3":{random_count:5},
        "4":{random_count:6},
        "5":{random_count:7},
        "6":{random_count:8},
        "7":{random_count:10},
        "8":{random_count:12},
        "9":{random_count:12},
    };
    var bossBox=main.find("#bossInfoJS");
    
    function bossAnim(){
        this.animIndex=_moduleTimeHandler.getNewIndex();
        this.queueIndex=_moduleTimeHandler.getNewIndex();
        this.pos=[600,300];
    }
    bossAnim.prototype={
        start:function(){
            var th=this;
            bossBox.animate({opacity:1},2200);
            _moduleTimeHandler.queueAdd(this.queueIndex,function(){
                bossBox.find(".descJS").animate({opacity:0},400);
                _moduleTimeHandler.setOne(th.animIndex,function(){
                    bossBox.find(".xJS").show().animate({opacity:1},400)
                    _moduleTimeHandler.queueTrigger(th.queueIndex);
                },400);
            });
            _moduleTimeHandler.queueAdd(this.queueIndex,function(){
                bossBox.animate({"margin-top":"-300px"},900);
            });
            _moduleTimeHandler.setOne(this.animIndex,function(){
                    _moduleTimeHandler.queueTrigger(th.queueIndex);
            },4000);
        },
        
    };
    var bossObj= new bossAnim();
    
    
    function gameObj(){
        this.lives=3;
        this.points=0;
        this.boss_cut=5;
    };
    gameObj.prototype={
        getLive:function(howmany,reason_id){
            /*
             * 1-CHICK
             * 2-EGG
             * 3-BOSS
             */
            if(reason_id==1){
                _mySound.playSound("chick_die");
            }
            this.lives-=howmany;  
            this.lives=Math.max(0,this.lives);
            if(this.lives<=0){
                _moduleEvents.trigger("game_fail",reason_id);
            }
            this.updateViewLives();
        },
        givePoints:function(howmany){
            this.points+=howmany;
            this.updateViewPoints();
            _mySound.playSound("game_cut_good_word");
        },
        makeCut:function(){
            this.boss_cut--;
            this.updateViewCut();
            _mySound.playSound("game_cut_good_word");
        },
        clear:function(){
            this.lives=3;
            this.points=0;
            this.updateViewLives();
            this.updateViewPoints();
            this.updateViewCut();
        },
        updateViewLives:function(){
            var liveObj=main.find(".boxLives .cell");
            var i;
            for(i=this.lives;i<3;i++){
                liveObj.eq(2-i).attr("data-active",1);
            }
        },
        updateViewPoints:function(){
            main.find("#showPointsJS").html(this.points);
        },
        updateViewCut:function(){
            bossBox.find("#bossInfoValJS").html(this.boss_cut);
        }
    };
    var gameState= new gameObj();
    function gameDuring(){
        var gameConf=[
            {egg_min:2,egg_max:2,chick_min:1,chick_max:1,cost:10},
            {egg_min:1,egg_max:2,chick_min:0,chick_max:0,cost:400},
            {egg_min:1,egg_max:2,chick_min:0,chick_max:0,cost:500}
        ]
        ,gameConfBase={
            "0":{egg_min:2,egg_max:3,chick_min:0,chick_max:1,cost:450}
        },
        gameBossConf={"0":{boss:1,egg:0,chick:0}};
        function prepareConfig(gameConf){
            if(level==0){
                return true;
            }
            var i,row;
            for(i in gameConf){
                row=gameConf[i];
                row.egg_min=Math.round(row.egg_min+level*0.15);
                row.egg_max=Math.round(row.egg_max+level*0.3);
                row.chick_min=Math.round(row.chick_min+level*0.15);
                row.chick_max=Math.round(row.chick_max+level*0.15);
            }
            
            
            gameBossConf[level]={boss:1,egg:Math.round(1+level*0.4),chick:Math.round(1+level*0.2)};
            var base=gameConfBase["0"];
            gameConfBase[level]={
                egg_min:Math.round(base.egg_min+Math.min(2,level*0.15)),
                egg_max:Math.round(base.egg_max+Math.min(3,level*0.3)),
                chick_min:Math.min(1,Math.round(base.chick_min+level*0.15)),
                chick_max:Math.min(2,Math.round(base.chick_max+level*0.3)),
                cost:Math.min(500,Math.round(400+level*15))
            };
            if(from_php.win_times>=4){
                gameConfBase[level]={
                    egg_min:Math.round(base.egg_min+Math.min(2,level*0.15)),
                    egg_max:Math.round(base.egg_max+Math.min(4,level*0.4)),
                    chick_min:Math.min(2,Math.round(base.chick_min+level*0.2)),
                    chick_max:Math.min(3,Math.round(base.chick_max+level*0.3)),
                    cost:Math.min(500,Math.round(400+level*15))
                };
                gameBossConf[level]={boss:1,egg:Math.round(2+level*0.5),chick:Math.round(1+level*0.3)};
            }
//            if(from_php.win_times>=4){
//                gameConfBase[level]={
//                    egg_min:Math.round(base.egg_min+Math.min(3,level*0.25)),
//                    egg_max:Math.round(base.egg_max+Math.min(5,level*0.5)),
//                    chick_min:Math.min(2,Math.round(base.chick_min+level*0.2)),
//                    chick_max:Math.min(4,Math.round(base.chick_max+level*0.4)),
//                    cost:Math.min(500,Math.round(400+level*15))
//                };
//                gameBossConf[level]={boss:1,egg:Math.round(3+level*0.5),chick:Math.round(1+level*0.4)};
//            }
        }
        prepareConfig(gameConf);
        var gameSetConf={
            "0":{w_margin:200,h_max:700,g:0.4},
            "1":{w_margin:180,h_max:720,g:0.45},
            "2":{w_margin:160,h_max:760,g:0.5},
            "3":{w_margin:140,h_max:800,g:0.55},
            "4":{w_margin:130,h_max:850,g:0.6},
            "5":{w_margin:120,h_max:900,g:0.65},
            "6":{w_margin:100,h_max:950,g:0.7},
            "7":{w_margin:80,h_max:1000,g:0.75},
            "8":{w_margin:70,h_max:1000,g:0.75},
            "9":{w_margin:50,h_max:1100,g:0.75}
        };
        if(from_php.win_times>=4){
            gameSetConf["8"].g=0.8;
            gameSetConf["8"].h_max=1100;
            gameSetConf["9"].g=0.85;
            gameSetConf["9"].h_max=1175;
        }
//        if(from_php.win_times>=4){
//            gameSetConf={
//                "0":{w_margin:200,h_max:700,g:0.55},
//                "1":{w_margin:180,h_max:720,g:0.6},
//                "2":{w_margin:160,h_max:760,g:0.65},
//                "3":{w_margin:140,h_max:800,g:0.70},
//                "4":{w_margin:120,h_max:900,g:0.75},
//                "5":{w_margin:100,h_max:1000,g:0.8},
//                "6":{w_margin:80,h_max:1100,g:0.85},
//                "7":{w_margin:60,h_max:1150,g:0.85},
//                "8":{w_margin:40,h_max:1200,g:0.85},
//                "9":{w_margin:20,h_max:1225,g:0.85}
//            };
//        }
        
                
        var stat=0;
        
        
        
        
        var step_arr={},state=0,step=50;
        var random_count;
        for(random_count=0;random_count<conf_general[level]["random_count"];){
            state++;
            step+=mt_rand(10,12);
            if(stat==0){
                if(gameConf.length){
                    stat=gameConf.shift();
                }
                else{
                    stat=gameConfBase[level];
                    random_count++;
                }
            }
            else{
                if(step>=stat.cost){
                    step-=stat.cost;
                    step_arr[state]={};
                    var len,key,i;
                    for(key in {egg:1,chick:1}){
                        len=mt_rand(stat[key+"_min"],stat[key+"_max"]);
                        step_arr[state][key]=len;
                        gameState[key+"_all"]+=len;
                    }
                    stat=0;
                }
            }
        }
        state+=30;
        step_arr[state]=copyObj(gameBossConf[level]);
        var state_max=state;
        state=0;
        _moduleTimeHandler.set(gameIndex,function(){
            state+=1;
            if(typeof step_arr[state]!="undefined"){
                var obj=step_arr[state];
                var len,key,i,qConf=copyObj(gameSetConf[level]),x_pos_last;
                if(typeof obj.boss!="undefined" && obj.boss){
                     bossObj.start();
                    _moduleTimeHandler.addOne(function(){
                        for(key in {boss:1,egg:1,chick:1}){
                            len=obj[key];
                            for(i=0;i<len;i++){
                                x_pos_last=gameCanvas.startGirlAnim("addCollisionThrow",key,copyObj(qConf));
                                if(key=="boss"){
                                    qConf.boss_x=x_pos_last;
                                }
                                if(key=="egg"){
                                    _moduleEvents.trigger("addEgg");
                                }
                                if(key=="chick"){
                                    _mySound.playSound("chick");
                                }
                            }

                        }
                    },6000);
                }
                else{
                    for(key in {egg:1,chick:1}){
                        len=obj[key];
                        for(i=0;i<len;i++){
                            gameCanvas.startGirlAnim("addCollisionThrow",key,copyObj(gameSetConf[level]));
                            if(key=="egg"){
                                _moduleEvents.trigger("addEgg");
                            }
                            if(key=="chick"){
                                _mySound.playSound("chick");
                            }
                        }

                    }
                }
            }
            if(state>state_max){
                _moduleTimeHandler.clear(gameIndex);
            }
        },100);
    }
    function startGame(){
        gameState.clear();
        
        
        ghostCanvas.myArcCanvas(pointsGame,_moduleTimeHandler,_moduleEvents,{"top":115,"left":19});
        var img_arr={
            "egg":"/gfx/place/gameninja/cutimages/egg.png",
            "boss":"/gfx/place/gameninja/cutimages/boss/boss.png",
            "egg_kill":_IMG_SERV+"/gfx/place/gameninja/cutimages/egg_kill.png"
        };
        var key,i,eggs=["blue","pink","purple","stripes","yblue"],k;
        for(i in eggs){
            key=eggs[i];
            img_arr["egg"+i]="/gfx/place/gameninja/cutimages/eggs/"+key+"/egg.png";
            for(k=0;k<4;k++){
                img_arr["egg"+i+"_"+k]=_IMG_SERV+"/gfx/place/gameninja/cutimages/eggs/"+key+"/"+k+".png";
            }
        }
        for(i=0;i<=6;i++){
            img_arr["chick"+i]="/gfx/place/gameninja/cutimages/chicken/a"+i+".png";
        }
        for(i=0;i<=2;i++){
            img_arr["chick_f"+i]=_IMG_SERV+"/gfx/place/gameninja/cutimages/chicken/f"+i+".png";
        }
        for(i=1;i<=4;i++){
            img_arr[("boss_c"+i)]=_IMG_SERV+"/gfx/place/gameninja/cutimages/boss/boss_c"+i+".png";
        }
        
//        gameState={good:0,bad:0,happy:0,step:100};
        gameCanvas.on("collisionEvent",function(e,data){
            if(data.eventType=="egg"){
                gameState.givePoints(1);
//                _mySound.playSound("game_cut_good_word");
//                animCanvas.startGirlAnim("addText",_LANGS["GIRLS-TPL_GAMEIN_CUT_GOOD"],[data.imgPos[0],780-data.imgPos[1]],"#465f13",20,"#ffffff",5,20);
            }
            if(data.eventType=="chick"){
                gameState.getLive(1,1);
//                _mySound.playSound("game_cut_bad_word");
//                animCanvas.startGirlAnim("addText",_LANGS["GIRLS-TPL_GAMEIN_CUT_BAD"],[data.imgPos[0],780-data.imgPos[1]],"#ff0000",20,"#ffffff",30,20);
            }
            if(data.eventType=="boss"){
                gameState.makeCut();
            }
        }).on("boss_killed",function(){
            _mySound.playSound("glass_crush");
            _moduleEvents.trigger("game_ready");
        }).on("moveEnd",function(e,data){
            
            if(data.eventType=="chick"){
                _mySound.playSound("chick_happy");
            }
            if(data.eventType=="egg"){
                _mySound.playSound("egg_crash");
                gameState.getLive(1,2);
            }
            if(data.eventType=="boss"){
                gameState.getLive(3,3);
            }
            
        }).one("was_loaded",function(){
            gameCanvas.startGirlAnim("setCollisionPoint",pointsGame);
            gameDuring();
            _moduleEvents.trigger("game_was_init");
        }).startGirlAnim({
            load_images:img_arr
        },_moduleTimeHandler);
        
        
        
        
        var body=$("body");
        body.addClass("noselect");
        _moduleEvents.one("moduleClear",function(){
           body.removeClass("noselect"); 
        });
        
    }
    function helpAnim(){
        var points=[
            [0,0],
            [51,72],
            [104,138],
            [156,196],
            [207,250]
        ];
        var funArr=new Smooth(points),points_len=points.length,step=0,step_max=100,
        obj=main.find("#helpHintJS"),animIndex=_moduleTimeHandler.getNewIndex(),waitIndex=_moduleTimeHandler.getNewIndex();
        
        function makeIt(){
            step=0;
            obj=main.find("#helpHintJS");
            obj.css({width:"0px",height:"0px"});
            obj.fadeIn(500);
            _moduleTimeHandler.setOne(waitIndex,function(){
                _moduleTimeHandler.set(animIndex,function(){
                    
                    step+=12;
                    if(step>step_max*(points_len-1)){
                        step=step_max*(points_len-1);
                        _moduleTimeHandler.clear(animIndex);
                        
                        obj.fadeOut(500);
                        _moduleTimeHandler.setOne(waitIndex,function(){
                            makeIt();
                        },550);
                    }
                    var point=funArr(step/step_max),
                    set_it={width:(Math.floor(point[0])+"px"),height:(Math.floor(point[1])+"px")};
                    obj.css(set_it);
                    
                    
                },40);
            },550);
            
        }
        makeIt();
    }
    function initStart(){
        book.show();
        var tmp=book.find(">.content");
        startCanvas.add(startImgCanvas).attr({width:tmp.width(),height:tmp.height()});
        startCanvas.myArcCanvas(pointsStart,_moduleTimeHandler,_moduleEvents,{"top":298,"left":354});
        var canvasPos=[434,250];//jsquery bug workaround;
        startImgCanvas.on("collisionEvent",function(e,coll){
            book.bookUse("hide");
            _moduleTimeHandler.clear(startIndex);
            pointsStart.splice(0,pointsStart.length);
            _mySound.playSound("game_cut_good_word");
            startGame();
            _moduleEvents.trigger("game_run");
        }).one("was_loaded",function(){
            startImgCanvas.startGirlAnim("setCollisionPoint",pointsStart);
            startImgCanvas.startGirlAnim("addCollisionStart",canvasPos,"egg");
           
        }).startGirlAnim({
            load_images:{
                "egg":"/gfx/place/gameninja/easter/start/egg.png",
            },
        },_moduleTimeHandler);
        helpAnim();
        
        book.find(".textfill").textfill();
        book.hide();
//        startImgCanvas.trigger("collisionEvent")
    }
    function initGame(){
        gameCanvas.add(ghostCanvas).attr({width:main.width(),height:main.height()});
    }
    function init(){
        main.one("myPreloaderInit",function(){

        }).one("myPreloaderEnd",function(){
            initStart();
            initGame();
            book.bookUse("show");
        }).myPreloader({urlArr:[
                _IMG_SERV+"/gfx/place/gameninja/easter/back/rabbit_action.jpg",
                _IMG_SERV+"/gfx/place/gameninja/easter/back/rabbit_wait.jpg"
        ],addToLoader:0},_moduleTimeHandler);
        
        
    }
    init();
    
    
    
//    startGame();
    
}